/*
Lalitha 12/19/2022 3075154998 Added Added Search Data Manager Record Form
Lalitha 12/20/2022  3075154998 Added Created Date Data Manager Form
Sohel  12/21/2022 3075154998 Added record Type Validation and dropdown values.
Lalitha 12/21/2022  3075154998 Integrated search Api
Suresh Peddavoora 01/04/2022 3075154998 Fixed Button Spacing Alignments
Suresh Peddavoora 01/04/2022 3075154998 Added Mapped Records functionality
Suresh Peddavoora  01/05/2023 3075154998 Fixed Spacing Alignments in DialogBox
Sohel 01/05/2022 3075154998 changed condition
Sohel 01/06/2023 2789725780 passed export type in payload
dilip 01/09/2023 2789725780 Added search data local storage
kavyareddy 01/10/2023 2789725780 Fixed code issue
Suresh Peddavoora 01/12/2023 2789725780 Changed Autocomplete dropdown font Alignments
dilip 01/12/2023 2789725780 Reset Parent Record.
dilip 01/12/2023 2789725780 Map Records Reset button issue.
 dilip 01/16/2023 2789725780 Added Master Record payload for search records.
Prakash 01/18/2023 2789725780 Fixed close and save buttons alignments.
Suresh Peddavoora 01/19/2023 2789725780 Fixed Buttons Rendering issue
Sohel 01/20/2023 2698964415 changed dropdown values
Ashraf 01/27/2023 2698964415 added new fields
Ravi 01/31/2023 2698964415 fixed unsaved popup issue
Sohel 01/02/2023 2698964415 fixed page break issue
Dilip 02/09/2023 2698964415 added creted for field
Sohel 01/08/2023 2701335619 Implemented Usage Functionality
Rohini 02/09/2023 2701335619 added classnames and enhancements in the text feilds
Dilip 02/10/2023 2698964415 added creted by field
Prakash 02/14/2023 2698964415 Reverted New UI Changes.
Prakash 02/16/2023 2698964415 Fixed UI-Bug.
Prakash 02/20/2023 2698964415 fixed alignment for dropdown.
suresh peddavoora 02/22/2023 2698964415 New UI changes fixed
suresh peddavoora 02/22/2023 2698964415 New UI changes fixed
suresh peddavoora 02/27/2023 2698964415 New UI changes
Raghu 02/27/2023 2698964415 fixed ui alignments
Rohini 02/28/2023 2698964415 changed the columns grid for screen enhancements.
suresh peddavoora 02/28/2023 2698964415 New UI changes fixed
suresh peddavoora 03/01/2023 2698964415 New UI changes
Rohini 03/03/2023 2698964415 fixed the alignment issues
Raghu 03/14/2023 2698964415 fixed the alignment issues in responsive
Raghu 03/14/2023 2698964415 fixed the alignment issues in responsive
Prakash 03/16/2023 2698964415 fixed ui bugs in responsive.
Prakash 03/17/2023 2698964415 fixed ui bugs in responsive.
T Santosh Kumar 17/03/2023 2698964415 New UI Alignment Changes
Akhila 06/08/2023 2698964415 title label placeholder name change
Akhila 06/08/2023 2698964415 rearrange the column and form fields
Akhila 06/09/2023 2698964415 bug fix label name condtionally implemented
Akhila 06/12/2023 2698964415 added role access
Prakash 22/06/2023 2698964415 fixed alignments issues
Sohel 11/12/2023 2698964415 code field removed upper case
Sohel 12/12/2023 2701335619 label name change code to name 
*/
import {Button, FormHelperText, TextField} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useEffect, useRef, useState, useContext} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {getDropDownData} from '../../../../../redux/reducers/BRE/AddRecordFormat';
import SearchDMRecordTable from './SearchDMRecordTable';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {filteredCheckedData, tempSelectFunc} from '../../../../../util/Functions';
import {setParentRecordException} from '../../../../../redux/reducers/DataManager';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
  getAllReportCreatedForData,
} from '../../../../../redux/reducers/ReportMaster';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {createForOptions, createdByOptions} from '../../../../../util/CreatedByForOptions';

import * as Yup from 'yup';
const recordType = [
  {value: 'New Account Import'},
  // { value: "New Payment Import" },
  {value: 'Data Update'},
  {value: 'Customer Query'},
  {value: 'Exception'},
  {value: 'Header'},
  {value: 'Footer'},
];

const StatusOptions = [
  {key: 'Y', value: 'Draft'},
  {key: 'N', value: 'Completed'},
];
const masterRecordOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

const SearchDataManagerRecord = ({
  setValue,
  mapRecord = false,
  handleClose,
  tempSelectedRows,
  setTempSelectedRows = () => {},
  recordGroupValues = {groupRecords: []},
  setDMFieldValue = () => {},
  recordGroupType,
  setRecords,
  records,
  isRecordGroup,
  fixedLength,
  exportManagerRecordGroup,
  mapRecordForException,
  mappedRecordForExceptionData,
  setMappedRecordForExceptionData,
  mappingMasterRecordTypes,
  setParentRecord = () => {},
  parentRecordException,
  masterRecordValue,
  includeAudit,
  category,
  handleDirty = () => {},
  setDataManagerRecordData = () => {},
  setEditExisting = () => {},
  dmTempRecordAccess,
  setImTemRecEditing,
}) => {
  const type = exportManagerRecordGroup ? 'Export' : 'Import';
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {createdForData, createdByData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const getMapRecord = (value) => {
    return masterRecordOptions?.filter((item) => item.key === value)?.[0];
  };

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item.value === option ||
          item.key === option ||
          item.userName === option ||
          item.categoryCode === option
        ) {
          label = item;
        }
      });
    return label;
  };

  const categoryData = [
    {
      categoryCode: 'CO',
      categoryName: 'Core',
    },
  ];

  const promptOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];

  const initialState = {
    code: '',
    recordDescription: '',
    recordType: mappingMasterRecordTypes ?
      mappingMasterRecordTypes :
      recordGroupType ?
        recordGroupType :
        '',
    isDraft: mapRecord ? {key: 'N', value: 'Completed'} : '',
    createdDate: null,
    fixedLength: isRecordGroup && fixedLength ? fixedLength : '',
    masterRecord: isRecordGroup ? getMapRecord(masterRecordValue) : '',
    category: category ? getObject(category, categoryData) : '',
    includeAudit: includeAudit ? getObject(includeAudit, promptOptions) : '',
    createdFor: '',
    createdBy: '',
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState(initialState);
  const [submit, setSubmit] = useState(false);
  const tempUnCheckedRef = useRef([]);

  const handleSubmit = (values) => {
    sessionStorage.setItem('IMRecord', JSON.stringify(values));
    setSearchData(values);
    setSubmit(true);
  };

  useEffect(() => {
    dispatch(getDropDownData());
    if (!mapRecord) {
      dispatch(setParentRecordException(null));
    }
  }, []);
  useEffect(() => {
    dispatch(fetchCreatedForDropDownData('importtemplaterecord'));
    dispatch(fetchCreatedByDropDownData('importtemplate'));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    setEditExisting && setEditExisting(false);
  }, []);

  const onClear = () => {
    const data = {
      code: '',
      recordDescription: '',
      recordType: mappingMasterRecordTypes ?
        mappingMasterRecordTypes :
        recordGroupType?.value ?
          recordGroupType :
          '',
      isDraft: mapRecord ? {key: 'N', value: 'Completed'} : '',
      createdDate: null,
      fixedLength: isRecordGroup && fixedLength ? fixedLength : '',
      masterRecord: isRecordGroup ? getMapRecord(masterRecordValue) : '',
      createdFor: '',
      createdBy: '',
    };
    setSearchData(data);
    sessionStorage.removeItem('IMRecord');
  };
  const IMRecordSessionStorage = JSON.parse(sessionStorage.getItem('IMRecord'));

  return (
    <div className={mapRecord ? `col-12` : ``}>
      <h2 className="search-title">Import Template Records Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={
          IMRecordSessionStorage && !mapRecord && !isRecordGroup ?
            IMRecordSessionStorage :
            initialState
        }
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {
            values,
            handleBlur,
            handleChange,
            handleReset,
            handleSubmit,
            setFieldValue,
            touched,
            errors,
          } = props;
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields">
                <div className={`col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                  <TextField
                    className={` ${classes.labelName} `}
                    placeholder={`Enter ${type} Template Record Name`}
                    margin="dense"
                    name="code"
                    variant="outlined"
                    value={values?.code}
                    label={`${type} Template Record Name`}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    fullWidth
                  />
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName} `}
                    placeholder={`Enter ${type} Template Description`}
                    margin="dense"
                    name="recordDescription"
                    value={values.recordDescription}
                    variant="outlined"
                    label={`${type} Template Description`}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    fullWidth
                  />
                </div>
                {!mappingMasterRecordTypes ? (
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="recordType"
                      id="recordType"
                      size="small"
                      value={values.recordType}
                      options={recordType}
                      disabled={recordGroupType}
                      // getOptionDisabled={(option) => option.valueCode === ""}
                      // getOptionLabel={(option) => {
                      //   return option && option.value
                      //     ? option.valueCode === null
                      //       ? option.value
                      //       : option.valueCode + " - " + option.value
                      //     : "";
                      // }}
                      getOptionLabel={(option) => {
                        return option?.value ? option?.value : '';
                      }}
                      autoHighlight
                      onChange={(e, value) => {
                        setFieldValue('recordType', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName} `}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Record Type"
                            placeholder="Select Record Type"
                          />
                        </div>
                      )}
                    />
                  </div>
                ) : (
                  <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group">
                    <TextField
                      className={` ${classes.labelName} `}
                      margin="dense"
                      value={mappingMasterRecordTypes?.toString()}
                      variant="outlined"
                      disabled
                      label="Record Type"
                      fullWidth
                    />
                  </div>
                )}
                {!mapRecord ? (
                  <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="masterRecord"
                      id="masterRecord"
                      size="small"
                      value={values.masterRecord}
                      options={masterRecordOptions}
                      disabled={isRecordGroup}
                      getOptionLabel={(option) => {
                        return option?.value || '';
                      }}
                      autoHighlight
                      onChange={(e, value) => {
                        setFieldValue('masterRecord', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName} `}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Master Record"
                            placeholder="Select Master Record"
                          />
                        </div>
                      )}
                    />
                  </div>
                ) : null}

                <div className={`col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group`}>
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="createdFor"
                    id="createdFor"
                    size="small"
                    value={values.createdFor}
                    options={createdForData}
                    getOptionLabel={(option) => {
                      return option && option?.userLoginName ? option?.userLoginName : '';
                    }}
                    renderOption={(option) => {
                      return createForOptions(option);
                    }}
                    onChange={(e, value) => {
                      setFieldValue('createdFor', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={` ${classes.labelName} `}
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Created For"
                          placeholder="Select Created For"
                        />
                      </div>
                    )}
                  />
                </div>

                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="createdBy"
                    id="createdBy"
                    size="small"
                    value={values.createdBy}
                    options={createdByData}
                    getOptionLabel={(option) => {
                      return option && option?.userLoginName ? option?.userLoginName : '';
                    }}
                    renderOption={(option) => {
                      return createdByOptions(option);
                    }}
                    onChange={(e, value) => {
                      setFieldValue('createdBy', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={` ${classes.labelName} `}
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Created By"
                          placeholder="Select Created By"
                        />
                      </div>
                    )}
                  />
                </div>

                <div className={`col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group`}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={` ${classes.labelName} `}
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      fullWidth
                      value={values.createdDate}
                      name="createdDate"
                      onBlur={handleBlur}
                      inputVariant="outlined"
                      helperText=""
                      label="Date Created"
                      error={Boolean(touched?.createdDate && errors?.createdDate)}
                      onChange={(val) => {
                        setFieldValue('createdDate', val);
                      }}
                      autoOk
                      margin="dense"
                    />
                  </MuiPickersUtilsProvider>

                  <FormHelperText variant="outlined">
                    {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                  </FormHelperText>
                </div>
                <div className={`col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group`}>
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="isDraft"
                    id="isDraft"
                    size="small"
                    options={StatusOptions}
                    required
                    value={values.isDraft}
                    disabled={mapRecord || isRecordGroup}
                    getOptionLabel={(option) => {
                      return option && option?.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('isDraft', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={` ${classes.labelName} `}
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Status"
                          placeholder="Select Status"
                        />
                      </div>
                    )}
                  />
                </div>
                {exportManagerRecordGroup && (
                  <>
                    <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                          popper: classes.popper,
                        }}
                        name="category"
                        id="category"
                        size="small"
                        disabled
                        value={values.category}
                        options={categoryData?.length > 0 ? categoryData : []}
                        getOptionDisabled={(option) => option.categoryCode === ''}
                        getOptionLabel={(option) => {
                          return option && option.categoryName ?
                            option.categoryCode === null ?
                              option.categoryName :
                              option.categoryCode + ' - ' + option.categoryName :
                            '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('category', value);
                        }}
                        placeholder="Select Category"
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName} `}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              name="category"
                              label="Category"
                              placeholder="Select Category"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        name="includeAudit"
                        id="includeAudit"
                        size="small"
                        disabled
                        options={promptOptions}
                        value={values.includeAudit}
                        getOptionLabel={(option) => {
                          return option && option?.value && option?.key ?
                            `${option?.key + ' - ' + option?.value}` :
                            option?.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('includeAudit', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName} `}
                              variant="outlined"
                              margin="dense"
                              InputLabelProps={{shrink: true}}
                              label="Include Audit"
                              placeholder="Select Include Audit"
                            />
                          </div>
                        )}
                      />
                    </div>
                  </>
                )}

                <div className={!mapRecord ? `col-md-4  col-lg-12 col-xl-12 form-group` : `d-none`}>
                  <div className=" d-flex justify-content-md-center justify-content-xl-center">
                    <Button
                      variant="outlined"
                      className={`mr-1 reset-btn`}
                      onClick={() => {
                        handleReset();
                        setSubmit(true);
                        onClear();
                      }}
                    >
                      Reset
                    </Button>
                    <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                      Search
                    </Button>
                  </div>
                </div>
              </div>

              <div
                className={
                  mapRecord ? `col-md-12 col-lg-12 form-group new-standard-textfields` : `d-none`
                }
              >
                <div className="form-row">
                  <div className="col-md-6">
                    <div className=" d-flex justify-content-md-end ">
                      <Button
                        variant="outlined"
                        className={`mr-1 reset-btn`}
                        onClick={() => {
                          handleReset();
                          setSubmit(true);
                          onClear();
                        }}
                      >
                        Reset
                      </Button>
                      <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                        Search
                      </Button>
                    </div>
                  </div>

                  {mapRecord ? (
                    <div className="col-md-6">
                      <div className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-end ">
                        <Button
                          aria-label="close"
                          variant="outlined"
                          className={`mr-1 reset-btn ${classes.buttonRoot}`}
                          onClick={() => {
                            handleClose();
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          aria-label="save"
                          variant="outlined"
                          className={`ml-1 search-btn ${classes.buttonRoot}`}
                          onClick={() => {
                            const obj = tempSelectFunc('recordCode', '', tempUnCheckedRef);
                            if (mapRecord) {
                              if (isRecordGroup) {
                                const [newSelectedRows] = filteredCheckedData(
                                  recordGroupValues.groupRecords,
                                  obj,
                                  'recordCode',
                                );
                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                setDMFieldValue('groupRecords', allSelectedRows);
                                setTempSelectedRows(allSelectedRows || []);
                              }
                              if (records) {
                                const [newSelectedRows] = filteredCheckedData(
                                  records,
                                  obj,
                                  'recordCode',
                                );
                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                setRecords(allSelectedRows);
                                setTempSelectedRows(allSelectedRows || []);
                              }
                              if (tempSelectedRows?.length > 0 && mapRecordForException) {
                                setMappedRecordForExceptionData(tempSelectedRows[0]);
                                setParentRecord('parentRecord', tempSelectedRows[0]?.recordCode);
                              }
                              handleClose();
                            }
                            handleDirty(true);
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              {/* {mapRecord ? (
                <div className={`col-md-12 col-lg-4 col-xl-12 mb-3`}>
                  <div className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-end">
                    <Button
                      aria-label="close"
                      variant="outlined"
                      className={`mr-1 reset-btn ${classes.buttonRoot}`}
                      onClick={() => {
                        handleClose();
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      aria-label="save"
                      variant="outlined"
                      className={`ml-1 search-btn ${classes.buttonRoot}`}
                      onClick={() => {
                        const obj = tempSelectFunc("recordCode", "", tempUnCheckedRef);
                        if (mapRecord) {
                          if (isRecordGroup) {
                            const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                              recordGroupValues.groupRecords,
                              obj,
                              "recordCode"
                            );
                            const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                            setDMFieldValue("groupRecords", allSelectedRows);
                            if (newUnSelectedRows.length > 0) {
                              const allDeleteIds = [];
                              newUnSelectedRows.forEach((el) => {
                                if (el.dmRecordGroupMappingId) {
                                  allDeleteIds.push(el.dmRecordGroupMappingId);
                                }
                              });

                              const ids = [...deletedIds, ...allDeleteIds];
                              setDeletedIds(ids);
                            }
                            setTempSelectedRows(allSelectedRows || []);
                          }
                          if (records) {
                            const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                              records,
                              obj,
                              "recordCode"
                            );
                            const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                            setRecords(allSelectedRows);
                            setTempSelectedRows(allSelectedRows || []);
                          }
                          handleClose();
                        }
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              ) : null} */}
            </form>
          );
        }}
      </Formik>
      <SearchDMRecordTable
        setValue={setValue}
        searchData={searchData}
        submit={submit}
        setSubmit={setSubmit}
        mapRecord={mapRecord}
        records={records}
        tempSelectedRows={tempSelectedRows}
        setTempSelectedRows={setTempSelectedRows}
        tempUnCheckedRef={tempUnCheckedRef}
        recordGroupValues={recordGroupValues}
        recordGroupType={recordGroupType}
        isRecordGroup={isRecordGroup}
        fixedLength={fixedLength}
        exportManagerRecordGroup={exportManagerRecordGroup}
        mapRecordForException={mapRecordForException}
        mappedRecordForExceptionData={mappedRecordForExceptionData}
        setMappedRecordForExceptionData={setMappedRecordForExceptionData}
        mappingMasterRecordTypes={mappingMasterRecordTypes}
        parentRecordException={parentRecordException}
        masterRecordValue={masterRecordValue}
        includeAudit={includeAudit}
        category={category}
        setDataManagerRecordData={setDataManagerRecordData}
        setEditExisting={setEditExisting}
        dmTempRecordAccess={dmTempRecordAccess}
      />
    </div>
  );
};
export default SearchDataManagerRecord;
